import store from "../redux/store";
import { SolaceConsumer } from "./types/SolaceConsumer";
import { ISolaceConsumer } from "./types/ISolaceConsumer";
import { SOLACE_PRICEING_DATA } from '../redux/actions/getPricingInfoActions';
import { SOLACE_PUBLISH_EVENTS_FAILURE, SOLACE_PUBLISH_EVENTS_SUCCESS } from '../redux/actions/publishSolaceEventActions';
import { SOLACE_CONSUME_EVENTS_FAILURE, SOLACE_CONSUME_EVENTS_SUCCESS } from '../redux/actions/consumeSolaceEventsActions';
import { GET_SUBSCRIBE_PRICE_SCREEN_DATA } from '../redux/actions/getSubscribePriceScreenActions';
import { decodeObjectValues } from "../components/shared/helpers";
// import { solaceTopicBrowserAdapterData } from "../actions";
// import log from "../../logger";

export const queueBrowser = (solaceModule: any, topicName: string, solaceCredentials : any, payload:string | null): ISolaceConsumer => {
    'use strict';
    var solace = solaceModule;

    var consumer: ISolaceConsumer = new SolaceConsumer()
    consumer.topicName = topicName
    // Logger
    consumer.log = (line: string) => {
        var now = new Date();
        var time = [('0' + now.getHours()).slice(-2), ('0' + now.getMinutes()).slice(-2),
            ('0' + now.getSeconds()).slice(-2)];
        var timestamp = '[' + time.join(':') + '] ';
        console.log(timestamp + line);
    };

    // main function
    consumer.run = () =>{
        console.log('\n*** browser to topic "' + consumer.topicName + '" is ready to connect ***');
        consumer.connect();
    };

    // Establishes connection to Solace message router
    consumer.connect = () => {
        if (consumer.session) {
            console.log('Already connected and ready to consume messages.');
            return;
        }

        let hosts: string[] = [];
        if(solaceCredentials['host']) {
            if(solaceCredentials['host'].indexOf(',') > -1) {
                hosts = solaceCredentials['host'].split(',')
            } else {
                hosts = [solaceCredentials['host']]
            }
        }
        const hosturls: string[] = []
        hosts.forEach((host: string) => {
            hosturls.push(host)
        })
        console.log('Connecting to Solace message router using url: ' + JSON.stringify(hosturls));
        var username = solaceCredentials['clientUsername'] ? solaceCredentials['clientUsername'] : '';
        console.log('Client username: ' + username);
        var vpn = solaceCredentials['messageVpn'] ? solaceCredentials['messageVpn'] : '';
        console.log('Solace message router VPN name: ' + vpn);
        var pass = solaceCredentials['clientPassword'] ? solaceCredentials['clientPassword'] : '';
        // create session
        try {
            consumer.session = solace.SolclientFactory.createSession({
                // solace.SessionProperties
                url:      hosturls,
                vpnName:  vpn,
                userName: username,
                password: pass,
                connectRetries: 3,
                connectRetriesPerHost: 3,
                reconnectRetries: -1
            });
        } catch (error) {
            // console.log(`Unable to establish session to Solace message router for queue ${consumer.topicName}, Exception : ${error}`);
        }

        // define session event listeners
        consumer.session.on(solace.SessionEventCode.UP_NOTICE, function (sessionEvent: any) {
            console.log(`Successfully connected to and ready to start the message consumer for topic ${consumer.topicName}`);
            if (payload) {
                consumer.publish(payload);
              } 
            else {
                consumer.startConsume(topicName);
              }
        });
        consumer.session.on(solace.SessionEventCode.CONNECT_FAILED_ERROR, function (sessionEvent: any) {
            console.log(`Connection failed to the Solace message router for topic ${consumer.topicName}, Exception :  ${sessionEvent.infoStr} - check correct parameter values and connectivity!`);
        });
        consumer.session.on(solace.SessionEventCode.DOWN_ERROR, function (sessionEvent: any) {
            console.log(`Connection failed to the Solace message router for topic ${consumer.topicName}, Exception :  ${sessionEvent.infoStr} - check correct parameter values and connectivity!`);
        });
        consumer.session.on(solace.SessionEventCode.DISCONNECTED, function (sessionEvent: any) {
            console.log(`Topic consumer for queue ${consumer.topicName} got disconnected`);
            consumer.consuming = false;
            if (consumer.session !== null) {
                consumer.session.dispose();
                consumer.session = null;
            }
        });

        try {
            consumer.session.connect();
           
        } catch (error) {
            // console.log(`An Unexpected error connecting to Solace message router for queue ${consumer.topicName}, Exception: ${error}`);
        }

    };

    consumer.startConsume = (topic:string) => {
        if (consumer.session !== null) {
            if (consumer.consuming) {
                console.log('Already started consumer for topic "' + consumer.topicName +
                    '" and ready to receive messages.');
            } else {
                console.log('Starting consumer for topic: ' + consumer.topicName);
                try {
                    // Create a message consumer
                    // consumer.messageConsumer = consumer.session.createMessageConsumer({
                    //     // solace.MessageConsumerProperties
                    //     queueDescriptor: { name: 'test', type: solace.QueueType.QUEUE },
                    //     acknowledgeMode: solace.MessageConsumerAcknowledgeMode.CLIENT, // Enabling Client ack
                    // });
                    consumer.messageConsumer = consumer.session.createMessageConsumer({
                        topicEndpointSubscription: topic,
                        queueDescriptor: { type: solace.QueueType.TOPIC_ENDPOINT, durable: false },
                        acknowledgeMode: solace.MessageConsumerAcknowledgeMode.CLIENT, // Enabling Client ack
                    });
                    // Define message consumer event listeners
                    consumer.messageConsumer.on(solace.MessageConsumerEventName.UP, function () {
                        consumer.consuming = true;
                        console.log(`Ready to receive messages from topic ${consumer.topicName}`);
                        store.dispatch({
                              type: SOLACE_CONSUME_EVENTS_SUCCESS,
                              payload: {
                                message: `Started Consuming messages for topic - ${topic}`,
                            },
                        })
                    });
                    consumer.messageConsumer.on(solace.MessageConsumerEventName.CONNECT_FAILED_ERROR, function () {
                        consumer.consuming = false;
                        console.log('=== Error: the message consumer could not bind to topic "' + consumer.topicName +
                            '" ===\n   Ensure this queue exists on the message router vpn');
                    });
                    consumer.messageConsumer.on(solace.MessageConsumerEventName.DOWN, function () {
                        consumer.consuming = false;
                        console.log(`=== The message consumer is now down for topic ${consumer.topicName} ===`);
                    });
                    consumer.messageConsumer.on(solace.MessageConsumerEventName.DOWN_ERROR, function () {
                        consumer.consuming = false;
                        console.log(`=== An error happened, the message consumer is down for topic ${consumer.topicName}===`);
                    });
                    // Define message received event listener
                    consumer.messageConsumer.on(solace.MessageConsumerEventName.MESSAGE, async function (message: any) {
                        try{
                        consumer.log('Received message: "' + message.getBinaryAttachment());
                        // Need to explicitly ack otherwise it will not be deleted from the message router
                        var topicName = message.getDestination().getName();
						var otopicData = message.getBinaryAttachment();
						if (message.getType() == solace.MessageType.TEXT) {
							otopicData = message.getSdtContainer().getValue();
	                    } else if (message.getType() == solace.MessageType.BINARY) {
                            otopicData = message.getBinaryAttachment();
                        } else if (message.getType() == solace.MessageType.MAP) {
							otopicData = message.getMap();
						} else {
							otopicData = message.getStream();
						}						
                        if (otopicData instanceof Uint8Array) {
                            otopicData = new TextDecoder('utf-8').decode(otopicData);
                        }
                        let topicData: any;
                        try {
                            topicData = JSON.parse(otopicData);
                        } catch (parseError) {
                            console.log(`Skipping non-JSON message on topic ${topicName}: "${otopicData}"`);
                            return;
                        }
                        topicData = decodeObjectValues(topicData);
                        console.log(`${topicName} for topic ${consumer.topicName}`);
                        store.dispatch({type : SOLACE_PRICEING_DATA ,payload:{topicName : consumer.topicName, topicData}});
                        store.dispatch({type : GET_SUBSCRIBE_PRICE_SCREEN_DATA,payload:{topicName : consumer.topicName, topicData}}) ;
                        }catch(exception){
                            console.log(`An exception occured - ${(exception as Error).message}`)
                            store.dispatch({type : SOLACE_CONSUME_EVENTS_FAILURE ,payload:{message : `An error occured while consuming messages - ${exception}`}});       
                        }
                        
                    });
                    // Connect the message consumer
                    consumer.messageConsumer.connect();
                } catch (error) {
                    console.log('An unexpected error occurred, Exception : ' + error);
                }
            }
        } else {
            console.log(`Cannot start the topic consumer for topic ${consumer.topicName} because not connected to Solace message router.`);
        }
    };

    consumer.publish = function (payload:any) {
        if (consumer.session !== null) {
            var message = solace.SolclientFactory.createMessage();
            // message.setDestination(solace.SolclientFactory.createDurableTopicDestination( consumer.topicName )); //Publish via queue
            message.setDestination(solace.SolclientFactory.createTopicDestination( consumer.topicName )); //Publish via topic
            message.setBinaryAttachment(payload);
            message.setDeliveryMode(solace.MessageDeliveryModeType.PERSISTENT);
            consumer.log('Publishing message "' + payload + '" to topic "' + consumer.topicName + '"...');
            try {
                consumer.session.send(message);
                consumer.log('Message published.');
                store.dispatch({type : SOLACE_PUBLISH_EVENTS_SUCCESS ,payload:{message : `Sucessfully published to this topic - ${consumer.topicName} and message - ${payload}`}});       
                // consumer.stopConsume();
                consumer.disconnect();
            } catch (error) {
                // consumer.log(error);
                store.dispatch({type : SOLACE_PUBLISH_EVENTS_FAILURE ,payload:{message : `An error occured while publishing messages - ${error}`}});       
            }
        } else {
            consumer.log('Cannot publish because not connected to Solace message router.');
        }
    };

    consumer.exit = () => {
        consumer.stopConsume();
        consumer.disconnect();
        setTimeout(function () {
            process.exit();
        }, 1000); // wait for 1 second to finish
    };

    // Gracefully disconnects from Solace message router
    consumer.disconnect = () => {
        console.log('Disconnecting from Solace message router...');
        if (consumer.session !== null) {
            try {
                consumer.session.disconnect();
            } catch (error) {
                console.log('An unexpected error occurred while disconnecting, Exception : '+error);
            }
        } else {
            console.log('Not connected to Solace message router.');
        }
    };

    consumer.stopConsume = () => {
        if (consumer.session !== null) {
            if (consumer.consuming) {
                consumer.consuming = false;
                // console.log('Disconnecting consumer from queue: ' + consumer.topicName);
                try {
                    consumer.messageConsumer.disconnect();
                    consumer.messageConsumer.dispose();
                } catch (error) {
                    //consumer.log(error);
                }
            } else {
                // console.log('Cannot disconnect the consumer because it is not connected to queue "' +
                //     consumer.topicName + '"');
            }
        } else {
            // console.log('Cannot disconnect the consumer because not connected to Solace message router due to invalid session.');
        }
    };

    // Actually connects the session triggered when the iframe has been loaded - see in html code
    consumer.connectToSolace =  ()=> {
        try {
            consumer.session.connect();
        } catch (error:any) {
            consumer.log(error.toString());
        }
    };

    return consumer;
}
